import { StyleSheet } from "react-native";
import type { Palette } from "@heraion/shared";

// AppShell's stylesheet, split out to keep AppShell.tsx under the size cap
// (prompt.md §Limiti di dimensione). Pure styling, no behaviour: same shapes,
// same values, same CONTENT_MAX consumers (AppShell's narrow TopBar maxWidth,
// navInner and bodyInner below) as when this lived inline in AppShell.tsx.

// Shared content column width — header, nav and body all centre to this
// so the console reads as one aligned column on wide screens.
export const CONTENT_MAX = 960;

// The un-capped pane wrapper: flex:1, full width, no maxWidth. Shared by
// SettingsScreen (the detail pane's non-catalog sub-screens) and
// MeContentPane (corpo/effort/timers): both wrap a stateful sub-screen in a
// stable `<View>` so it survives a wide/narrow resize (MX-8) instead of the
// node disappearing entirely on one side of the breakpoint, and this is the
// "no cap" value that wrapper's style toggles to on wide's non-form panes
// and on narrow throughout. One object instead of two byte-identical ones
// (formCap/meFormCap keep their own cap, per surface, and stay put).
export const PANE_FLEX = StyleSheet.create({ pane: { flex: 1, width: "100%" } })
  .pane;

export function makeStyles(p: Palette) {
  return StyleSheet.create({
    // Positioned so TabBar (narrow) can pin itself to this container's own
    // bottom edge via `position: "absolute"` rather than the viewport's.
    shell: { flex: 1, backgroundColor: p.bg, position: "relative" },
    // Wide console: row of [rail | content]. Content reclaims the full
    // remaining width (the per-surface multi-column treatment lands in the
    // next phase); the rail stays put while the surface scrolls itself.
    shellRow: { flex: 1, flexDirection: "row", backgroundColor: p.bg },
    contentWide: {
      flex: 1,
      minWidth: 0,
      maxWidth: 1320,
      paddingHorizontal: 24,
      paddingVertical: 16,
    },
    body: { flex: 1 },
    bodyInner: {
      flex: 1,
      width: "100%",
      maxWidth: CONTENT_MAX,
      marginHorizontal: "auto",
    },
    soloTitle: {
      color: p.ink,
      fontSize: 20,
      fontWeight: "700",
      paddingHorizontal: 16,
      paddingTop: 16,
    },
  });
}
